import {FilteredListPageLayout} from '@github-ui/layout-primitives/FilteredListPageLayout'
import type {MouseEventHandler} from 'react'

export function ViewsBackLink({
  viewsPath,
  onClick,
}: {
  viewsPath: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
}) {
  return (
    // eslint-disable-next-line @github-ui/dotcom-primer/no-title-case -- baselined during linter rollout
    <FilteredListPageLayout.PageHeader.ParentLink href={viewsPath} hidden={false} onClick={onClick}>
      Back to Views
    </FilteredListPageLayout.PageHeader.ParentLink>
  )
}
